import { render, staticRenderFns } from "./ExamManagement.vue?vue&type=template&id=5bc62f72&scoped=true"
import script from "./ExamManagement.vue?vue&type=script&lang=js"
export * from "./ExamManagement.vue?vue&type=script&lang=js"
import style0 from "./ExamManagement.vue?vue&type=style&index=0&id=5bc62f72&prod&scoped=true&lang=css"
import style1 from "./ExamManagement.vue?vue&type=style&index=1&id=5bc62f72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc62f72",
  null
  
)

export default component.exports